import { ReactNode } from "react";

import { default as VFModal } from "@vfuk/core-modal";
import { ModalProps as VFModalProps } from "@vfuk/core-modal/dist/Modal.types";
import { OverlayProvider } from "@vfuk/core-overlay-controller";

interface ModalProps {
  isOpen: boolean;
  onClose?: VFModalProps["onCloseCb"];
  isClosable?: boolean;
  animate?: boolean;
  srName: string;
  size?: VFModalProps["size"];
  children: ReactNode;
}

export const Modal = (props: ModalProps) => {
  const {
    isOpen = false,
    onClose,
    isClosable = true,
    animate = true,
    size = 4,
    children,
    srName = "",
  } = props;
  return (
    <OverlayProvider>
      <VFModal
        srName={srName}
        isOpen={isOpen}
        size={size}
        animate={animate}
        isClosable={isClosable}
        onCloseCb={onClose}
      >
        <>{children}</>
      </VFModal>
    </OverlayProvider>
  );
};
